<template>
  <b-modal title="Informações Sobre o Equipamento Armazenado" v-model="show" size="lg">
    <b-container fluid>
      <b-row class="mt-2">
        <b-col cols="11">
          <b-form-group label="Descrição:" label-for="descricao" label-cols="3" label-align="right">
            <b-form-input id="descricao" v-model="editing.descricao" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col cols="11">
          <b-form-group label="Código:" label-for="codigo" label-cols="3" label-align="right">
            <b-form-input id="codigo" v-model="editing.codigo" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col cols="11">
          <b-form-group label="Estado:" label-for="estado" label-cols="3" label-align="right">
            <b-form-input id="estado" v-model="editing.estado" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col cols="11">
          <b-form-group label="Quantidade:" label-for="qtd" label-cols="3" label-align="right">
            <b-form-input id="qtd" v-model="editing.quantidade" type="number" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col cols="11">
          <b-form-group label="Observação:" label-cols="3" label-align="right">
            <b-form-textarea v-model="editing.observacao" rows="3"></b-form-textarea>
          </b-form-group>
        </b-col>
      </b-row>
    </b-container>

    <!-- :::::::::::::::::::::::::::: MODAIS DE USO :::::::::::::::::::::::::::: -->
    <equipamento-list ref="equipamentoListaArm" />

    <template #modal-footer>
      <b-button variant="primary" @click="salvar()">Salvar</b-button>
      <b-button variant="info" @click="equipamentos()" class="pl-2 pr-3"> Equipamentos </b-button>
      <b-button variant="secondary" @click="show = !show">Fechar</b-button>
    </template>
  </b-modal>
</template>

<script>
import { useSgcqStore } from "@/stores/SgcqStore";
import { useArmazemStore } from "@/stores/ArmazemStore";
import Armazem from "@/models/Armazem";
import Notificacao from "@/models/Notificacao";
import EquipamentoListModal from "@/components/modals/equipamento/EquipamentoListModal";

export default {
  name: "ModalDeEdicaoDeArmazenados",

  components: {
    "equipamento-list": EquipamentoListModal,
  },

  data() {
    return {
      show: false,
      editing: new Armazem(0, "Novo Equipamento", "", "", 0, "informações importantes sobre o equipamento."),
    };
  },

  methods: {
    salvar() {
      if (this.editing.id != 0) {
        this.armazemStore.ALTERAR_ARMAZENADOS(this.editing).then(() => {
          this.store.NOTIFICAR(new Notificacao("Equipamento armazenado no SGCQ com sucesso!", "Excelente!", "success"));
        });
      } else {
        this.armazemStore.CADASTRAR_ARMAZENADOS(this.editing).then(() => {
          this.store.NOTIFICAR(new Notificacao("Equipamento armazenado salvo no SGCQ com sucesso!", "Excelente!", "success"));
        });
      }
      this.show = !this.show;
    },

    equipamentos() {
      this.$refs.equipamentoListaArm.call();
    },

    call(prioridade) {
      this.show = !this.show;
      this.editing = prioridade;
    },
  },

  setup() {
    const store = useSgcqStore();
    const armazemStore = useArmazemStore();

    return {
      store,
      armazemStore,
    };
  },
};
</script>

<style lang="scss" scoped></style>
